export class Translations {
  unitHeader: string;
  subUnitHeader: string;
}
